module.exports = __webpack_public_path__ + "static/media/r1.b488b566.png";